module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-Bold.1c2a702.eot";